// extracted by mini-css-extract-plugin
var _1 = "LoaderStyle-module__load7___bBsaS";
var _2 = "LoaderStyle-module__loader___ecdi0";
var _3 = "LoaderStyle-module__loader-full-width___tbc_C";
var _4 = "LoaderStyle-module__loader-small___DxhCc";
var _5 = "LoaderStyle-module__loader-space___Chw3y";
var _6 = "LoaderStyle-module__loader__container___g6U6M";
var _7 = "LoaderStyle-module__loader-full-width___tbc_C";
var _8 = "LoaderStyle-module__loader-small___DxhCc";
var _9 = "LoaderStyle-module__loader-space___Chw3y";
var _a = "LoaderStyle-module__loader__container___g6U6M";
var _b = "LoaderStyle-module__posRel___OUDLf";
export { _1 as "load7", _2 as "loader", _3 as "loader-full-width", _4 as "loader-small", _5 as "loader-space", _6 as "loaderContainer", _7 as "loaderFullWidth", _8 as "loaderSmall", _9 as "loaderSpace", _a as "loader__container", _b as "posRel" }
